const authState = {
    isLoading: false,
    userData: {
        email: '',
        password: ''
    }
}

const Auth = ( state = authState, action )=>{
    switch (action.type) {
        case 'AUTH_TOGGLE_LOADER':
            return { ...state,
                isLoading: action.isLoading
            }
        default: 
            return {...state};
      }  
}

export default Auth;